export default __webpack_public_path__ + "static/media/user.7495b3d4.png";